module.exports = __webpack_public_path__ + "img/robot.abc37249.png";